import { makeStyles } from 'tss-react/mui';

import {
  Theme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

const useStyles = makeStyles()((theme: Theme) => ({
  popupContainer: {
    '& .MuiDialog-paper': {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.common.white,
      minHeight: 'auto',
      padding: '32px',
      borderRadius: '16px',
    },

    '& .MuiDialogContentText-root': {
      color: theme.palette.secondary.main,
    },
  },
  popupActions: {
    display: 'flex',
    justifyContent: 'center',
    gap: '16px',
    padding: 0,
    marginTop: '32px',

    '@media (max-width: 550px)': {
      flexDirection: 'column',
      gap: '16px',

      '@media (max-width: 550px)': {
        paddingRight: '16px',
      },
    },
  },
  popupSelectButton: {
    color: theme.palette.common.white,
    background: theme.palette.info.main,
    maxWidth: '200px',
    width: '100%',
    borderRadius: '12px',
    height: '48px',

    '&.Mui-disabled': {
      color: 'rgba(255, 255, 255, 0.08)',
      background: 'rgba(255, 255, 255, 0.08)',
    },

    '&:hover': {
      background: theme.palette.info.main,
    },

    '@media (max-width: 550px)': {
      maxWidth: '100%',
    },
  },
  popupOkayButton: {
    color: theme.palette.common.white,
    background: theme.palette.info.main,
    maxWidth: '200px',
    borderRadius: '12px',
    width: '100%',
    height: '48px',
    textTransform: 'none',

    '&.Mui-disabled': {
      color: 'rgba(255, 255, 255, 0.08)',
      background: 'rgba(255, 255, 255, 0.08)',
    },

    '&:hover': {
      background: theme.palette.info.dark,
    },

    '@media (max-width: 550px)': {
      maxWidth: '100%',
    },
  },
  popupContent: {
    overflowY: 'hidden',
    marginTop: '32px',
    padding: 0,
    flex: 'none',
  },
  noResultsText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
 
  dialogContentText: {
     fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '16.8px',
    color: theme.palette.text.disabled,
  },
  dialogContent: {
    padding: 1,
    
  },

  resultItemContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    padding: '10px',
    borderRadius: '5px',
    gap: '50px',

    '@media (max-width: 550px)': {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },

    '&:hover': {
      cursor: 'pointer',
      backgroundColor: 'rgba(255, 255, 255, 0.19)',
    },
  },
  resultItemColumn: {
    display: 'flex',
    flexDirection: 'column',
    flexBasis: '33%',
    whiteSpace: 'nowrap',
    minWidth: 0,
  },
  resultItemColumnLabel: {
    fontSize: '12px',
    fontWeight: '500',
    color: '#93959E',
    fontFamily: 'Inter',
  },
  resultItemColumnText: {
    fontSize: '16px',
    fontWeight: '500',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontFamily: 'Inter',
  },
  resultItemActiveBgColor: {
    backgroundColor: 'rgba(255, 255, 255, 0.19)',

    '@media (max-width: 550px)': {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      flexBasis: '33%',
      whiteSpace: 'nowrap',
      minWidth: 0,
    },
  },
  dialogTitle: {
    padding: 0,
    fontSize: '23px',
    lineHeight: '41px',
    fontWeight: 500,
    fontFamily: 'Inter',
    textAlign: 'left',
    marginBottom: '12px',

    '@media (max-width: 600px)': {
      fontSize: '16px',
    },
  },
  formWrapper: {
    '@media (max-width: 550px)': {
      paddingRight: '16px',
    },
  },
}));

interface UnableMemoPopupProps {
  isOpen: boolean;
  onMainButtonClick?: () => void;
  onSecondaryButtonClick?: () => void;
}

const UnableMemoPopup = ({
  isOpen,
  onMainButtonClick,
  onSecondaryButtonClick,
}: UnableMemoPopupProps) => {
  const styles = useStyles();

  const handleClosePopup = () => {
    if (onSecondaryButtonClick) {
      onSecondaryButtonClick();
    } else if (onMainButtonClick) {
      onMainButtonClick();
    }
  };

  return (
    <Dialog
      className={styles.classes.popupContainer}
      open={isOpen}
      onClose={handleClosePopup}
      fullWidth
    >
      <DialogTitle className={styles.classes.dialogTitle}>
        Unable to Use Memo
      </DialogTitle>

      <DialogContent className={styles.classes.dialogContent}>
        <Typography className={styles.classes.dialogContentText}>
          We are unable to use this memo for auto-fill.
        </Typography>
        <Typography className={styles.classes.dialogContentText}>
          You can upload another memo or continue with manual entry.
        </Typography>
      </DialogContent>
      <DialogActions className={styles.classes.popupActions}>
        <Button className={styles.classes.popupOkayButton} onClick={handleClosePopup}>
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnableMemoPopup;
